import { jwtDecode } from "jwt-decode";
import { useEffect } from "react";
import { DecodedUser } from "../../hooks/user/interface";
import useAuthStore from "../../store/Auth";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES, AUTH_ROUTES, ROUTE_NAMES } from "../../routes";
import Loader from "../../components/loader";
import { RolePrivilege } from "../../store/Auth/interface";
import { USER_ROLES_IDS } from "../../constants/common";
import { useGetUserPrivileges } from "../../hooks/user/mutation";

const SignInOidc = () => {
  const { setUserData, setIsLoggedIn, setToken, setUserRoles } = useAuthStore();

  const navigate = useNavigate();

  const { mutateAsync: GetUserPrivileges } = useGetUserPrivileges();

  useEffect(() => {
    const handleSignIn = async () => {
      const params = new URLSearchParams(window.location.hash.substring(1));
      const token = params.get("token");
      const error = params.get("error");

      try {
        if (token) {
          const decodedUser: DecodedUser = jwtDecode(token);

          const user = {
            user_id: Number(decodedUser?.UserId),
            username: decodedUser?.Username,
            firstname: decodedUser?.FullName.split(" ")[0],
            lastname: decodedUser?.FullName.split(" ")[1],
            email: decodedUser?.Email,
            n_RoleID: Number(decodedUser?.RoleId),
            n_LocationID: Number(decodedUser?.LocationID),
            isSSOLogin: true,
          };
          setUserData(user);
          setIsLoggedIn(true);
          setToken(token);

          if (decodedUser?.RoleId) {
            const privileges = await GetUserPrivileges();

            setUserRoles(privileges);

            if (token) {
              setIsLoggedIn(true);
            }

            if (Object.keys(privileges).length > 0) {
              const isHomePrivilege = privileges?.rolePrivileges?.some(
                (privilege: RolePrivilege) =>
                  privilege.s_RouteName === ROUTE_NAMES.HOME_SEARCH
              );

              const isApproveVisitRequestsPrivilege =
                privileges?.rolePrivileges?.some(
                  (privilege: RolePrivilege) =>
                    privilege.s_RouteName ===
                    ROUTE_NAMES.APPROVE_VISIT_REQUEST_SEARCH
                );

              const isApprovePermitRequestsPrivilege =
                privileges?.rolePrivileges?.some(
                  (privilege: RolePrivilege) =>
                    privilege.s_RouteName ===
                    ROUTE_NAMES.APPROVE_PERMIT_REQUEST_SEARCH
                );

              if (
                Number(decodedUser?.RoleId) === USER_ROLES_IDS.ADMIN ||
                Number(decodedUser?.RoleId) === USER_ROLES_IDS.SECURITY ||
                Number(decodedUser?.RoleId) ===
                  USER_ROLES_IDS.SECURITY_MANAGER ||
                Number(decodedUser?.RoleId) === USER_ROLES_IDS.RECEPTION
              ) {
                navigate(
                  isHomePrivilege ? APP_ROUTES.HOME : APP_ROUTES.UNAUTHORIZED
                );
              } else if (
                Number(decodedUser?.RoleId) === USER_ROLES_IDS.DIRECT_MANAGER ||
                Number(decodedUser?.RoleId) === USER_ROLES_IDS.INVENTORY_MANAGER
              ) {
                navigate(
                  isApprovePermitRequestsPrivilege
                    ? APP_ROUTES.APPROVE_PERMIT_REQUEST
                    : APP_ROUTES.UNAUTHORIZED
                );
              } else {
                navigate(
                  isApproveVisitRequestsPrivilege
                    ? APP_ROUTES.APPROVE_VISIT_REQUEST
                    : APP_ROUTES.UNAUTHORIZED
                );
              }
            }
          }
        } else if (error) {
          navigate(`${AUTH_ROUTES.LOGIN}#error=${error}`);
        } else {
          navigate(AUTH_ROUTES.LOGIN);
        }
      } catch (error) {
        navigate(AUTH_ROUTES.LOGIN);
      }
    };

    handleSignIn();
  }, [
    GetUserPrivileges,
    navigate,
    setIsLoggedIn,
    setToken,
    setUserData,
    setUserRoles,
  ]);

  return (
    <div className="flex justify-center py-[2vh]">
      <Loader />
    </div>
  );
};

export default SignInOidc;
